import styled from 'styled-components';
import { Button } from '@components/form-elements/buttons/Button';

export const StyledButton = styled(Button)`
  box-sizing: border-box;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
`;
